export const SURVEY_NAMEPSACE = 'survey'
export const DEFAULT_LANGUAGE = 'en'
